import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { http } from '@/lib/api';
import { Play, Pause, ArrowLeft } from 'lucide-react';
import PageHero from '@/components/PageHero';

// TODO: replace with MCCN-owned audio URLs via CMS. Placeholder public sample audio.
const SAMPLE = "https://actions.google.com/sounds/v1/ambiences/coffee_shop.ogg";

export default function Podcast() {
  const [eps, setEps] = useState([]);
  const [playing, setPlaying] = useState(null);
  const audioRef = useRef(null);
  useEffect(() => { http.get('/podcast').then(r => setEps(r.data)); }, []);

  const toggle = (ep) => {
    const url = ep.audio_url || SAMPLE;
    if (playing === ep.id) { audioRef.current?.pause(); setPlaying(null); return; }
    if (audioRef.current) audioRef.current.pause();
    audioRef.current = new Audio(url);
    audioRef.current.play(); setPlaying(ep.id);
    audioRef.current.onended = () => setPlaying(null);
  };

  return (
    <div className="p-6 space-y-4" data-testid="podcast-page">
      <Link to="/app" data-testid="podcast-back" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy">
        <ArrowLeft size={14}/> Back to home
      </Link>
      <PageHero photo="podcast" alt="A Black man in reflection" />
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold">Podcast</p>
        <h1 className="font-heading text-3xl mt-1">Conversations for the culture.</h1>
      </div>
      {eps.map(ep => (
        <div key={ep.id} data-testid={`podcast-${ep.id}`} className="bg-white rounded-3xl p-5 card-soft flex items-center gap-4">
          <button onClick={()=>toggle(ep)} data-testid={`podcast-play-${ep.id}`}
            className="w-12 h-12 rounded-full bg-navy text-white flex items-center justify-center hover:bg-navy-soft shrink-0">
            {playing === ep.id ? <Pause size={16}/> : <Play size={16}/>}
          </button>
          <div className="flex-1 min-w-0">
            <p className="font-heading text-lg truncate">{ep.title}</p>
            <p className="text-xs text-navy/60">{ep.guest} · {ep.duration}</p>
            <p className="text-sm text-navy/70 mt-1 line-clamp-2">{ep.description}</p>
          </div>
        </div>
      ))}
      <p className="text-[11px] text-navy/40 text-center pt-4">Audio placeholder — MCCN admins can add real audio URLs via the CMS.</p>
    </div>
  );
}
